/*
 uiHelper

 This class provides ui helper functions

 */

import $ from 'jquery';

var UIHelper = (function () {

    function uiHelper() { }

    uiHelper.prototype.isMobileDevice = function () {
        var result = false;

        //Detect touch events or pointer events, i.e. mobile device
        if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
            if (window.innerWidth < 992) {
                result = true;
            }
        }

        return result;
    };

    uiHelper.prototype.useDesktopSite = function (useDesktop) {

        if (useDesktop !== undefined && useDesktop !== null) {
            localStorge.setItem("useDesktopSite", useDesktop);
        }
        else if (localStorage.getItem("useDesktopSite") === null) {
            localStorage.setItem("useDesktopSite", this.isMobileDevice() === false);
        }

        return localStorage.getItem("useDesktopSite");
    };

    /**
     * Deletes a cookie.
     * 
     * @param {string} name The cookie name.
     */
    uiHelper.prototype.deleteCookie = function (name) {
        document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=Strict`;
    }

    uiHelper.prototype.setCookie = function (cookieName, cookieValue, expirationDays) {
        var d = new Date();
        d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

        if (expirationDays) {
            var expires = "expires=" + d.toUTCString();
            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Strict";
        }
        else {
            document.cookie = cookieName + "=" + cookieValue + ";path=/;SameSite=Strict";
        }
    }

    uiHelper.prototype.getCookie = function (cookieName) {
        var name = cookieName + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /**
     * Retrieves the URI-encoded cookie value as an object.
     * 
     * @param {string} name The cookie name.
     */
    uiHelper.prototype.getUriEncodedCookie = function (name) {
        const value = this.getCookie(name);

        if (!value) return undefined;

        /**
         * @type {{[key: string]: string}}
         */
        const object = {};

        for (const [k, v] of decodeURIComponent(value).split('&').map(property => property.split('=')))
            object[k] = v;

        return object;
    }

    /**
     * Indicates whether a cookie exists.
     * 
     * @param {string} name The cookie name.
     */
    uiHelper.prototype.hasCookie = function (name) {
        return document.cookie.includes(`${name}=`);
    }

    uiHelper.prototype.copyToClipboard = function (elementId) {

        const el = document.getElementById(elementId);

        if (el === null) {
            console.log("Text could not be copied to clipboard");
            return;
        }

        const content = el.innerHTML;
        navigator.clipboard.writeText(content)
            .then(() => {
                console.log("Text copied to clipboard...")
            })
            .catch(err => {
                console.log("Text could not be copied to clipboard", err);
            })
    }

    return uiHelper;
})();

export const uiHelper = new UIHelper();
